import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-usenas',
  templateUrl: './page-usenas.component.html',
  styleUrls: ['./page-usenas.component.css']
})
export class PageUsenasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
